import React, { useEffect, useState } from 'react';
import './Table.css'

interface Score {  
  realWorldScore: number;
  domainName: string;
  category: string;
}

const ScoreAnalyticsTable: React.FC = () => {
  const [scores, setScores] = useState<Score[]>([]);

  useEffect(() => {
    fetch('/api/domain-models/topScores')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data: Score[]) => {
            setScores(data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
}, []);





  return (
    <div>
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Category</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        {scores.map((score, index) => (
          <tr key={index}>
            <td>{score.domainName}</td>
            <td>{score.category}</td>
            <td>{score.realWorldScore}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
};

export default ScoreAnalyticsTable;
